import type { Viewer } from '../../../viewer/Viewer';
import { MoveComponentRotateInputMode } from '../MoveComponentTypes';
import { RotateService } from './RotateService';
import type { AssemblyTransformHistoryRecord } from '../../component-instance';

/**
 * 装配体旋转子控制器。
 */
export class RotateController {
  private readonly viewer: Viewer;
  private readonly rotateService: RotateService;
  private rotateInputMode: MoveComponentRotateInputMode;

  /**
   * 创建旋转子控制器。
   *
   * @param viewer 场景视图实例。
   * @param rotateService 旋转服务。
   * @param defaultInputMode 默认输入模式。
   */
  public constructor(
    viewer: Viewer,
    rotateService: RotateService,
    defaultInputMode: MoveComponentRotateInputMode,
  ) {
    this.viewer = viewer;
    this.rotateService = rotateService;
    this.rotateInputMode = defaultInputMode;
  }

  /**
   * 获取当前旋转输入模式。
   *
   * @returns 当前输入模式。
   */
  public getRotateInputMode(): MoveComponentRotateInputMode {
    return this.rotateInputMode;
  }

  /**
   * 设置旋转输入模式。
   *
   * @param mode 目标模式。
   */
  public setRotateInputMode(mode: MoveComponentRotateInputMode): void {
    this.rotateInputMode = mode;
  }

  /**
   * 预览 Delta XYZ 旋转。
   *
   * @param deltaRotation 旋转增量。
   */
  public previewDeltaRotate(deltaRotation: readonly [number, number, number]): void {
    this.rotateService.previewRotateByDelta(deltaRotation);
  }

  /**
   * 提交旋转预览。
   */
  public commitPreview(): AssemblyTransformHistoryRecord | null {
    const record = this.rotateService.commitPreview();
    void this.viewer;

    return record;
  }

  /**
   * 回滚旋转预览。
   */
  public cancelPreview(): void {
    this.rotateService.cancelPreview();
    void this.viewer;
  }

  /**
   * 释放旋转控制器资源。
   */
  public dispose(): void {
    this.rotateService.dispose();
    void this.viewer;
  }
}
